import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    logo: {
        height: 22,
        width: "auto",
        display: "block",

        [theme.breakpoints.down("xs")]: {
            height: 18,
        },
    },
    toolbar: {
        justifyContent: "space-between",

        [theme.breakpoints.down("xs")]: {
            flexWrap: "wrap",
            rowGap: 6,
            paddingTop: 6,
            paddingBottom: 6,
        },
    },
    languages_container: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        [theme.breakpoints.down("sm")]: {
            marginRight: 15,
        },
        [theme.breakpoints.down("xs")]: {
            marginRight: 8,
            fontSize: ".8125rem",
        },
    },
    languages_item: {
        cursor: "pointer",
    },
    languages_item__active: {
        fontWeight: 600,
    },
    languages_separator: {
        margin: "0 5px",
        fontSize: 14,
        opacity: 0.5,
        [theme.breakpoints.down("xs")]: {
            margin: "0 3px",
            fontSize: 12,
        },
    },
    user_container: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        marginLeft: 15,
        position: "relative",

        "&:hover": {
            "& .sing_out_button": {
                display: "inline",
            }
        }
    },
    sign_out_button__inline: {
        marginLeft: 16,
    },
    sign_out_button: {
        position: "absolute",
        display: "none",
        bottom: -35,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
    },
    user_avatar: {
        height: 30,
        width: 30,
        fontSize: 16,
        marginRight: 5,
        backgroundColor: theme.palette.secondary.main,
    },
    user_email: {
        textTransform: "lowercase",
        color: "#fff",
        fontSize: 16,
    }
}))